import { render, staticRenderFns } from "./changgou.vue?vue&type=template&id=1a83130d&scoped=true"
import script from "./changgou.vue?vue&type=script&lang=js"
export * from "./changgou.vue?vue&type=script&lang=js"
import style0 from "./changgou.vue?vue&type=style&index=0&id=1a83130d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a83130d",
  null
  
)

export default component.exports